import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ThemeProvider = ({ children }) => {
  const { primaryColor } = useSelector((state) => state.theme);

  useEffect(() => {
    // Apply the primary color as a CSS custom property
    const root = document.documentElement;
    root.style.setProperty('--custom-yellow', primaryColor);
    
    // Also update the colorSchems.aispace equivalent
    root.style.setProperty('--aispace-color', primaryColor);
    
    // Generate hover color (slightly darker)
    const darkerColor = adjustBrightness(primaryColor, -20);
    root.style.setProperty('--custom-yellow-hover', darkerColor);
    
    // Generate focus ring color (slightly transparent)
    const focusColor = adjustBrightness(primaryColor, 0, 0.2);
    root.style.setProperty('--custom-yellow-focus', focusColor);
    
  }, [primaryColor]);

  // Helper function to adjust color brightness
  const adjustBrightness = (hex, percent, alpha = 1) => {
    // Remove the # if present
    hex = hex.replace('#', '');
    
    // Parse the hex color
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Adjust brightness
    const adjustedR = Math.max(0, Math.min(255, r + percent));
    const adjustedG = Math.max(0, Math.min(255, g + percent));
    const adjustedB = Math.max(0, Math.min(255, b + percent));
    
    // Convert back to hex
    const adjustedHex = `#${Math.round(adjustedR).toString(16).padStart(2, '0')}${Math.round(adjustedG).toString(16).padStart(2, '0')}${Math.round(adjustedB).toString(16).padStart(2, '0')}`;
    
    // If alpha is specified, return rgba
    if (alpha < 1) {
      return `rgba(${adjustedR}, ${adjustedG}, ${adjustedB}, ${alpha})`;
    }
    
    return adjustedHex;
  };

  return <>{children}</>;
};

export default ThemeProvider; 